import { Navigate, useLocation } from "react-router-dom";
import useUserStore from "../store/userStore";
import Layout from "./Layout";
import useTokenLogin from "../hooks/useTokenLogin";
import { useEffect } from "react";

const PrivateAdminRoute = () => {
    var token = useUserStore((state) => state.token);
    const setToken = useUserStore((state) => state.setToken);
    var isAdmin = useUserStore((state) => state.isAdmin);
    const setDestinyRoute = useUserStore((state) => state.setDestinyRoute);
    const location = useLocation();

    const { mutate, isPending } = useTokenLogin();

    useEffect(() => {
        if (!token) {
            const localToken = localStorage.getItem("token");
            if (localToken) {
                mutate(localToken, {
                    onSuccess: (data) => {
                        setToken(data);
                        token = data.token;
                        isAdmin = data.isAdmin;
                    },
                    onError: () => {
                        localStorage.removeItem("token");
                    },
                });
            }
        }
    }, [token, mutate, setToken]);

    if (isPending) return <>Loading...</>;
    if (token && isAdmin) return <Layout />;

    if (!token) {
        setDestinyRoute(location.pathname);
        return <Navigate to="/login" />;
    }
    if (!isAdmin) {
        return <Navigate to="/" />;
    }
    return <>Error!</>;
};

export default PrivateAdminRoute;
